export default __webpack_public_path__ + "static/media/ts-6-8.ae7a4c19.svg";